const GB_US_CA = { USD: 150, AUD: 250, CAD: 250, EUR: 150, GBP: 150, NZD: 300, ZAR: 2500 };
/**
 * Monthly price of a phone number in minor units, by number country then subscription currency (#6731). Source for
 * the Stripe prices made by the Create Phone Number Prices admin script. Annual subscriptions pay 12x on an annual price.
 */
export const PHONE_NUMBER_MONTHLY_PRICE_CENTS = {
    NZ: { USD: 400, AUD: 550, CAD: 550, EUR: 350, GBP: 300, NZD: 650, ZAR: 6050 },
    AU: { USD: 350, AUD: 500, CAD: 500, EUR: 350, GBP: 300, NZD: 650, ZAR: 5800 },
    GB: GB_US_CA,
    US: GB_US_CA,
    CA: GB_US_CA,
};
/** Each subscription holds this many numbers, across all its organisations, at no charge. The oldest ones are free */
export const FREE_PHONE_NUMBERS = 1;
/** What one number adds per billing interval, in minor units. index is its place among the subscription's numbers, oldest first. Null when the currency has no price */
export function phoneNumberAmountCents(isoCountry, index, currency, annual) {
    var _a;
    if (index < FREE_PHONE_NUMBERS)
        return 0;
    const monthly = currency ? (_a = PHONE_NUMBER_MONTHLY_PRICE_CENTS[isoCountry]) === null || _a === void 0 ? void 0 : _a[currency.toUpperCase()] : undefined;
    return monthly === undefined ? null : monthly * (annual ? 12 : 1);
}
const PHONE_NUMBER_LOOKUP_PREFIX = `phone-number-`;
export function phoneNumberLookupKey(isoCountry, annual) {
    return `${PHONE_NUMBER_LOOKUP_PREFIX}${isoCountry.toLowerCase()}${annual ? `-annual` : ``}`;
}
export function isPhoneNumberLookupKey(lookupKey) {
    return !!(lookupKey === null || lookupKey === void 0 ? void 0 : lookupKey.startsWith(PHONE_NUMBER_LOOKUP_PREFIX));
}
//# sourceMappingURL=phoneNumbers.js.map